import { render, staticRenderFns } from "./c-address-popover.vue?vue&type=template&id=cf3f6062&scoped=true&"
import script from "./c-address-popover.vue?vue&type=script&lang=js&"
export * from "./c-address-popover.vue?vue&type=script&lang=js&"
import style0 from "./c-address-popover.vue?vue&type=style&index=0&id=cf3f6062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3f6062",
  null
  
)

export default component.exports